import { FormHelperText } from '@mui/material'
import React from 'react'

function TextError(props) {
  return <FormHelperText sx={{color:'#f3aaa4', borderColor: '#f3aaa4'}}>{props.children}</FormHelperText>
}

export default TextError
